/** Search parameters used in the services page. */
export const searchParametersServices = {
    CLIENTS: 'clients',
    MANAGERS: 'managers',
    NAME: 'name',
}

/** Search parameters used in the services API. */
export const searchParametersServicesApi = {
    CLIENTS: 'client__id__in',
    MANAGERS: 'client__client__id__in',
    NAME: 'name__icontains',
}
